import React, { Component } from "react";
import { Row, Col } from "antd";
// import "./fx";
// import "../../../public/index.html"
import "./livechat.style.css";

/* global CXBus */ // Tell ESLint that CXBus is a global variable

export default class Livechat extends Component {
  constructor(props) {
    super(props);
    // console.log('components/livechat');
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://apps.mypurecloud.jp/widgets/9.0/cxbus.min.js";
    script.onload = () => {
      if (window.CXBus) {
        window.CXBus.configure({
          debug: false,
          pluginsPath: "https://apps.mypurecloud.jp/widgets/9.0/plugins/",
        });
        window.CXBus.loadPlugin("widgets-core");
      } else {
        console.error("CXBus failed to load");
      }
    };
    script.onerror = () => console.error("Failed to load CXBus script");
    document.body.appendChild(script);
  }

  webstart = () => {
    if (!this.customPlugin) {
      // Register the plugin only if it hasn't been registered yet
      this.customPlugin = CXBus.registerPlugin("Custom");
    }

    if (this.customPlugin && typeof this.customPlugin.command === "function") {
      // console.log("Executing WebChat.open command");
      this.customPlugin.command("WebChat.open", this.getAdvancedConfig());
    } else {
      console.error("customPlugin.command is not a function or unavailable");
    }
  };

  getAdvancedConfig() {
    return {
      form: {
        autoSubmit: false,
        firstname: "",
        email: "",
        lastname: "",
        subject: "",
      },
      formJSON: {
        wrapper: "<table></table>",
        inputs: [
          {
            id: "cx_webchat_form_firstname",
            name: "firstname",
            maxlength: "100",
            placeholder: "Required",
            label: "Name",
            autocomplete: "off",
            validateWhileTyping: true,
            validate: function (event, form, input) {
              return input?.val()?.length >= 4;
            },
          },
          {
            id: "cx_webchat_form_email",
            name: "email",
            maxlength: "100",
            placeholder: "Required",
            label: "Email",
            autocomplete: "off",
            validateWhileTyping: true,
            validate: function (event, form, input) {
              const mailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
              return mailRegEx.test(input?.val());
            },
          },
        ],
      },
    };
  }

  render() {
    return (
      <div className="navbar" id="livechatButton">
        <button className="button" type="button" id="chat-button" onClick={this.webstart} style={{ fontFamily: "verdana" }}>
          <i className="fa fa-comments-o fa-lg"></i>
          <p className="livechatText" id="TextButton">
            Live Chat
          </p>
        </button>
      </div>
    );
  }
}
